import { searchCompanies } from 'proposals/api/procurementApiClient'
import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useQuery, UseQueryResult, UseMutationResult, useMutation } from '@tanstack/react-query'
import { useDebounce } from 'utils/useDebounce'

export const useSearchCompanies = (
  searchTerm: string,
  region: string
): UseQueryResult<SearchCompaniesResponseType[]> => {
  const debounceValue = useDebounce<string>(searchTerm, 500)

  return useQuery<SearchCompaniesResponseType[]>({
    queryKey: ['companies', debounceValue],
    queryFn: () => searchCompanies(debounceValue, region),
    refetchOnWindowFocus: false,
    enabled: debounceValue.length > 2
  })
}

export const useCheckRepresentationRightsOfCompany = (): UseMutationResult<
  boolean,
  unknown,
  CheckRepresentationRightsRequestType,
  unknown
> => {
  const { checkRepresentationRights } = useVendorsApiClient()

  return useMutation({
    mutationFn: (payload: CheckRepresentationRightsRequestType) => checkRepresentationRights(payload)
  })
}
